import React, { useState } from 'react';
import { loadConfigGeneric } from './app_config';
import { LoadingMessage } from './config_builder.style';
export const ConfigContext = React.createContext(undefined);
export const ConfigBuilderGeneric = (props) => {
    const [config, setConfig] = useState();
    if (!config) {
        loadConfigGeneric(props.configPath, props.baseURL, props.codec).then((config) => setConfig(config));
        return React.createElement(LoadingMessage, null, "Loading Config...");
    }
    else {
        return (React.createElement(ConfigContext.Provider, { value: config },
            React.createElement(props.context.Provider, { value: config }, props.children)));
    }
};
